import clsx from "clsx"
import { Icon } from "src/components/icon"
import { Heading } from "src/components/heading"
import { Text } from "src/components/text"

function Loader({ className }) {
  return (
    <svg viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg" className={clsx("size-28", className)}>
      <defs>
        <linearGradient id="barGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style={{ stopColor: "rgb(16, 185, 129)", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "rgb(5, 150, 105)", stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <g transform="translate(200, 200)">
        <rect x="-119" y="-70" width="38" height="140" rx="19" fill="url(#barGradient)">
          <animate attributeName="height" values="140;100;140" dur="1.2s" repeatCount="indefinite" begin="0s" />
          <animate attributeName="y" values="-70;-50;-70" dur="1.2s" repeatCount="indefinite" begin="0s" />
          <animate attributeName="opacity" values="1;0.5;1" dur="1.2s" repeatCount="indefinite" begin="0s" />
        </rect>

        <rect x="-69" y="-90" width="38" height="180" rx="19" fill="url(#barGradient)">
          <animate attributeName="height" values="180;130;180" dur="1.2s" repeatCount="indefinite" begin="0.15s" />
          <animate attributeName="y" values="-90;-65;-90" dur="1.2s" repeatCount="indefinite" begin="0.15s" />
          <animate attributeName="opacity" values="1;0.5;1" dur="1.2s" repeatCount="indefinite" begin="0.15s" />
        </rect>

        <rect x="-19" y="-110" width="38" height="220" rx="19" fill="url(#barGradient)">
          <animate attributeName="height" values="220;160;220" dur="1.2s" repeatCount="indefinite" begin="0.3s" />
          <animate attributeName="y" values="-110;-80;-110" dur="1.2s" repeatCount="indefinite" begin="0.3s" />
          <animate attributeName="opacity" values="1;0.5;1" dur="1.2s" repeatCount="indefinite" begin="0.3s" />
        </rect>

        <rect x="31" y="-90" width="38" height="180" rx="19" fill="url(#barGradient)">
          <animate attributeName="height" values="180;130;180" dur="1.2s" repeatCount="indefinite" begin="0.45s" />
          <animate attributeName="y" values="-90;-65;-90" dur="1.2s" repeatCount="indefinite" begin="0.45s" />
          <animate attributeName="opacity" values="1;0.5;1" dur="1.2s" repeatCount="indefinite" begin="0.45s" />
        </rect>

        <rect x="81" y="-70" width="38" height="140" rx="19" fill="url(#barGradient)">
          <animate attributeName="height" values="140;100;140" dur="1.2s" repeatCount="indefinite" begin="0.6s" />
          <animate attributeName="y" values="-70;-50;-70" dur="1.2s" repeatCount="indefinite" begin="0.6s" />
          <animate attributeName="opacity" values="1;0.5;1" dur="1.2s" repeatCount="indefinite" begin="0.6s" />
        </rect>
      </g>
    </svg>
  )
}

function LoadingPage() {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-olive-100 dark:bg-olive-900">
      <Loader />
    </div>
  )
}

function ErrorPage() {
  return (
    <div className="flex flex-col gap-3 items-center justify-center h-screen bg-olive-100 dark:bg-olive-900">
      <Icon icon="ExclamationTriangle" className="w-12 h-12 !text-red-500 mb-4" />
      <Heading className="text-center font-serif !text-xl sm:!text-2xl">Error loading</Heading>
      <Text className="text-center font-serif !text-base sm:!text-sm">Please refresh the page</Text>
    </div>
  )
}

export { Loader, LoadingPage, ErrorPage }
